// Client-side billing helpers (display only — server is authoritative).
import { api } from "./apiClient";

export const PLAN_NAMES = {
  free: "Free",
  starter: "Starter",
  professional: "Professional",
  business: "Business",
  enterprise: "Enterprise",
};

export const fetchWallet = () => api.get("/billing/wallet").then((r) => r.data);
export const fetchPlans = () => api.get("/billing/plans").then((r) => r.data);
export const fetchPacks = () => api.get("/billing/credit-packs").then((r) => r.data);
export const fetchHistory = () => api.get("/billing/usage-history").then((r) => r.data);
export const estimate = (payload) => api.post("/billing/estimate", payload).then((r) => r.data);

// Stripe Checkout (Phase 2)
export const createCheckout = (packId) =>
  api
    .post("/billing/checkout", { pack_id: packId, origin_url: window.location.origin })
    .then((r) => r.data);

export const fetchCheckoutStatus = (sessionId) =>
  api.get(`/billing/checkout/${sessionId}/status`).then((r) => r.data);

export const fetchPayments = () => api.get("/billing/payments").then((r) => r.data);

// Subscriptions (monthly recurring)
export const subscribe = (planId) =>
  api
    .post("/billing/subscribe", { plan_id: planId, origin_url: window.location.origin })
    .then((r) => r.data);

export const fetchSubscription = () => api.get("/billing/subscription").then((r) => r.data);

export const cancelSubscription = () => api.post("/billing/subscription/cancel").then((r) => r.data);

export const formatEur = (n) => (n == null ? "Custom" : `€${n}`);
